export default {
    meta: {
        title: '企业管理',
    },
};
